import { useEffect, useRef, useState, useCallback } from "react";
import { api, WS_URL } from "@/lib/clinic";

export function useQueue() {
  const [patients, setPatients] = useState([]);
  const [current, setCurrent] = useState(null);
  const [medico, setMedico] = useState(null);
  const [connected, setConnected] = useState(false);
  const [lastEvent, setLastEvent] = useState(null);
  const wsRef = useRef(null);
  const retryRef = useRef(null);

  const refetch = useCallback(async () => {
    const { data } = await api.get("/state");
    setPatients(data.patients || []);
    setCurrent(data.current || null);
    setMedico(data.medico || null);
  }, []);

  useEffect(() => {
    let closed = false;

    const connect = () => {
      if (closed) return;
      const ws = new WebSocket(WS_URL);
      wsRef.current = ws;

      ws.onopen = () => setConnected(true);
      ws.onmessage = (e) => {
        const msg = JSON.parse(e.data);
        if (msg.patients) {
          setPatients(msg.patients);
          setCurrent(msg.current || null);
          setMedico(msg.medico || null);
        }
        setLastEvent({ type: msg.type, payload: msg.payload, message: msg.message, at: Date.now() });
      };
      ws.onclose = () => {
        setConnected(false);
        if (!closed) retryRef.current = setTimeout(connect, 2000);
      };
      ws.onerror = () => ws.close();
    };

    refetch().catch(() => {});
    connect();

    return () => {
      closed = true;
      clearTimeout(retryRef.current);
      wsRef.current?.close();
    };
  }, [refetch]);

  return { patients, current, medico, connected, lastEvent, refetch };
}
